import React from 'react'

import { Button } from 'ui/components/Button'
import { Input } from 'ui/components/Input'
import {
    Popup,
    PopupCloseTrigger,
    PopupContent,
    PopupFooter,
    PopupInner,
    PopupTitle,
    PopupTrigger,
} from 'ui/components/Popup'
import { stopPropagation } from 'ui/helpers/utilities'

import { useManageDataTabRenamePopupState } from './hooks/useManageDataTabRenamePopupState'

type ManageDataTabRenameRef = HTMLButtonElement

type ManageDataTabRenamePopupProps = React.ComponentPropsWithoutRef<typeof PopupTrigger> & {
    open: boolean
    onOpenChange: (open: boolean) => void
    children: React.ReactNode
    objectSid: string
}

export const ManageDataTabRenamePopup = React.forwardRef<
    ManageDataTabRenameRef,
    ManageDataTabRenamePopupProps
>(({ children, objectSid, open, onOpenChange, ...props }, ref) => {
    const { onPointerDownOutside, onChange, localName, onSave } = useManageDataTabRenamePopupState({
        objectSid,
        onOpenChange,
    })

    return (
        <Popup modal={false} open={open} onOpenChange={onOpenChange}>
            <PopupTrigger asChild ref={ref} {...props}>
                {children}
            </PopupTrigger>
            <PopupContent
                style={{ width: '330px' }}
                onPointerDownOutside={onPointerDownOutside}
                onCloseAutoFocus={stopPropagation}
            >
                <form onSubmit={onSave}>
                    <PopupTitle>Rename table</PopupTitle>
                    <PopupInner>
                        <Input onChange={onChange} value={localName} autoFocus />
                    </PopupInner>
                    <PopupFooter layout="right">
                        <PopupCloseTrigger asChild>
                            <Button size="s" variant="ghost">
                                Cancel
                            </Button>
                        </PopupCloseTrigger>
                        <Button size="s" onClick={onSave} type="submit">
                            Save
                        </Button>
                    </PopupFooter>
                </form>
            </PopupContent>
        </Popup>
    )
})
